import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: start;
  align-self: flex-start;
  flex-direction: column;
  width: 100%;
  background: #0f6fdd;
  padding: 10px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  .link {
    color: #fff;
  }
`;
